function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15 19.5L15 5.25C15 4.83579 14.6642 4.5 14.25 4.5L6 4.5C5.58579 4.5 5.25 4.83579 5.25 5.25L5.25 18.75C5.25 19.1642 5.58579 19.5 6 19.5H15ZM15 19.5H18.75C19.1642 19.5 19.5 19.1642 19.5 18.75V10.5C19.5 10.0858 19.1642 9.75 18.75 9.75H15.75C15.3358 9.75 15 10.0858 15 10.5V19.5ZM7.875 7.875H8.625M7.875 10.125H8.625M7.875 12.375H8.625M11.625 7.875L12.375 7.875M11.625 10.125H12.375M11.625 12.375H12.375M16.875 12.375H17.625M16.875 14.625H17.625M16.875 16.875H17.625M12 19.5L12 15C12 14.5858 11.6642 14.25 11.25 14.25L9 14.25C8.58579 14.25 8.25 14.5858 8.25 15V19.5H12Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgMyClients(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyClients);
export default __webpack_public_path__ + "static/media/my-clients.b9e076cc.svg";
export { ForwardRef as ReactComponent };